<app-support-gridview [config]="config" (onEdit)="onEdit($event)" (onRemove)="onRemove($event)"></app-support-gridview>